import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_1ARed_1BBlack_1EBlue = () => <CrossRoad coords="1104.000000, 999.000000"/>;
export default CrossRoad_1ARed_1BBlack_1EBlue;
